module.exports = {
  "add_banner": {
    "title": "Add Banner",
    "description": "Customize",
    "sub_text": "your banner",
    "options": {
      "paperflite": "Paperflite",
      "pexels": "Pexels",
      "image": "image",
      "images": "Images",
      "videos": "Videos",
      "pick_from_pages":"Pick from Pages",
      "pick_from_video": "Pick from video",
    }
  },
  "crop": {
    "actions": {
      "done": "Done",
    }
  },
  "actions": {
    "upload_from_device": "Upload from device",
    "position": "Position",
    "filter": "Filter",
    "color": "Color",
    "done": "Done",
    "crop": "Crop",
    "show_shared_by": "Show shared by",
    "make_this_as_thumbnail": "Make this as thumbnail",
  },
  "filters": {
    "all_categories": "All Categories",
    "random": "Random",
    "real_estate": "Real Estate",
    "finance": "Finance",
    "marketing": "Marketing",
    "foot_beverages": "Food & Beverages",
    "health_care": "Health Care",
    "computer_software": "Computer Software",
    "education": "Education",
    "technology": "Technology"
  },
  "error_messages":{
    "banner_exceed": "Please upload a file of size less than {size}",
    "no_results_found": "No results found"
   }
}